<template>
	<div class="other_page_r">
		<el-card class="card_box">
			<div slot="header" class="card_title">
				<span>资讯管理/bot管理</span>
			</div>
			<div>
				<el-form
					:inline="true"
					:model="searchInfo"
					class="demo-form-inline margin_top_20 margin_left_20"
				>
					<el-form-item label="名称">
						<el-input
							class="custom_input_170"
							v-model="searchInfo.title"
							placeholder=""
						></el-input>
					</el-form-item>
					<el-form-item label="推送状态" prop="status">
						<el-select v-model="searchInfo.status" placeholder="">
							<el-option label="未推送" value="0"> </el-option>
							<el-option label="推送成功" value="1"> </el-option>
							<el-option label="推送失败" value="2"> </el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="bot类型" prop="type">
						<el-select v-model="searchInfo.type" placeholder="">
							<el-option label="文章" value="0"> </el-option>
							<el-option label="活动" value="1"> </el-option>
						</el-select>
					</el-form-item>

					<el-form-item>
						<el-button type="primary" @click="searchBtn">查询</el-button>
						<el-button type="primary" @click="reset">重置</el-button>
						<el-button type="primary" @click="addArticle"
							>添加文章Bot</el-button
						>
						<el-button type="primary" @click="addEvent">添加活动Bot</el-button>
					</el-form-item>
				</el-form>
			</div>
			<div class="table_box">
				<tablec :tableData="tableData"></tablec>
			</div>
			<div
				class="flex justify_content_end aligin_items_c table_footer custom_btn"
			>
				<div>
					<pagination
						v-show="total > 0"
						:total="total"
						:page.sync="searchInfo.page"
						:limit.sync="searchInfo.size"
						@pagination="getDataList"
					/>
				</div>
			</div>
		</el-card>
	</div>
</template>

<script>
import tablec from "./tablec.vue";
import { botLists } from "@/api/article";
import { searchMixin } from "@/utils/searchMixin.js";
export default {
	components: { tablec },
	mixins: [searchMixin],
	name: "",
	data() {
		return {
			title: "bot新增",
			tableData: [],
			total: 0,
			searchInfo: {
				page: 1,
				size: 10,
				title: "",
				status: "",
				type: "",
			},
		};
	},
	created() {
		this.getDataList();
	},
	methods: {
		searchBtn() {
			this.searchInfo.page = 1;
			this.getDataList();
		},
		addEvent() {
			this.$router.push({
				path: "/information/botEventDetail",
				query: { type: "create" },
			});
		},
		addArticle() {
			this.$router.push({
				path: "/information/botArticleDetail",
				query: { type: "create" },
			});
		},
		getDataList() {
			botLists(this.searchInfo)
				.then((res) => {
					if (res.code == 200) {
						this.tableData = res.data.list;
						this.total = res.data.total;
					} else {
						this.tableData = [];
						this.total = 0;
					}
					this.loading = false;
				})
				.catch((error) => {
					this.$message.error(error.message);
				});
		},
	},
};
</script>

<style scoped></style>
